<template>
    <div
        v-if="isVisible"
        @click.stop="handleFrameClick"
        @contextmenu.prevent.stop="handleContextMenu"
        @mousedown.stop="handleMouseDown"
        @mouseup.stop="handleMouseUp"
        @mousemove.stop="handleMouseMove"
        @mouseover.stop="handleMouseOver"
        @mouseleave="handleMouseLeave"
        :class="[
            'interactive-pin',
            { 'interactive-pin--with-line': showPinLine, selected: selected },
        ]"
        :style="pinStyle"
    >
        <div class="interactive-pin-content" :style="contentStyle">
            <lucide-icon
                v-if="shape.options.pin.icon.name"
                class="interactive-pin-icon"
                :icon="shape.options.pin.icon.name"
                :size="iconSize"
            />
            <div class="interactive-pin-text" v-if="shape.translations.content">
                {{ contentTranslate }}
            </div>
        </div>
        <span class="interactive-pin-line"></span>
        <span class="interactive-pin-point"></span>
    </div>
</template>

<script>
import { LayerShapeMixin } from "./LayerShapeMixin.js";
export default {
    name: "Pin",
    mixins: [LayerShapeMixin],
    computed: {
        iconSize() {
            return this.shape?.options?.pin?.icon?.size || 14;
        },
        showPinLine() {
            return this.pinLineHeight > 0;
        },
        pinLineHeight() {
            const pin = this.shape?.options?.pin;
            return pin ? pin.offset.y : 0;
        },
        contentStyle() {
            const { options } = this.shape;
            const { pin } = options;

            const currentStyle = options[this.style] || {};

            return {
                width: `${pin.diameter}px`,
                height: `${pin.diameter}px`,
                flex: `0 0 ${pin.diameter}px`,
                background: currentStyle.fill?.color || "#fff",
                border: `${currentStyle.stroke?.width || 1}px solid ${
                    currentStyle.stroke?.color || "#000"
                }`,
                borderRadius: `${pin.stroke?.radius || 0}px`,
                color: currentStyle.text?.color || "#000",
                fontSize: `${pin.text?.size || 14}px`,
                flexDirection: this.contentTranslate ? "column" : "row",
            };
        },
        pinStyle() {
            const { center, options } = this.shape;
            const pin = options.pin;

            const offsetCenterX = center.x / this.aspectRatio;
            const offsetCenterY = center.y / this.aspectRatio;
            const currentStyle = options[this.style] || {};

            return {
                top: `${offsetCenterY}px`,
                left: `${offsetCenterX}px`,
                transform: `scale(${this.scale}) translate(-50%, -100%)`,
                transformOrigin: `left top`,

                "--offsetY": `${this.pinLineHeight}px`,
                "--border-width": `${currentStyle.stroke?.width || 0}px`,
                "--line-color": currentStyle.stroke?.color || "#000",
                "--line-width": `${options.default?.stroke?.width || 1}px`,
                "--line-height": `${this.pinLineHeight}px`,
                "--point-diameter": `${pin.point?.diameter || 0}px`,
                "--point-radius": `${pin.point?.radius || 0}px`,
                "--point-color": pin.point?.color || "#000",
            };
        },
    },
};
</script>
